module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-7GENNAIO-25-small-063f303b67129d92bb53787369565cbd.png";